<template>
  <div>
    <!-- search -->
    <fragment>
      <search-nav @handleSearch="handleSearch" class="mb-8">
        <search-nav-year-month class="mr-4" label="검진기간" v-model="yearMonth" :use-all-year="false" :use-all-month="false"/>
      </search-nav>
    </fragment>
    <div class="flex justify-end gap-4 w-full text-right mb-4 px-4 xl:px-0">
       <vs-button class="mr-4" color="secondary" type="border" @click="onClickDownload">Excel 다운로드</vs-button>
    </div>

    <!-- 1차검진 결과 -->
    <fragment>
      <vs-row class="mt-8 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 1차검진 결과</h5>
        </vs-col>
      </vs-row>
      <table v-if="table1"
             class="w-full text-center"
             cellspacing="0">
        <colgroup>
          <col width="200"/>
          <col width="200"/>
          <col width="150"/>
          <col width="150"/>
          <col width="150"/>
          <col width="150"/>
          <col width="150"/>
          <col width="150"/>
          <col width="150"/>
          <col width="150"/>
        </colgroup>
        <thead>
        <tr>
          <th rowspan="3">구분</th>
          <th rowspan="3">수검자 수</th>
          <th colspan="2">검진 결과 인원</th>
          <th colspan="6" class="head-color">이상소견</th>
        </tr>
        <tr>
          <th rowspan="2">이상소견 없음</th>
          <th rowspan="2">이상소견 있음</th>
          <th class="head-color">2</th>
          <th class="head-color">2b</th>
          <th class="head-color">3</th>
          <th class="head-color">4A</th>
          <th class="head-color">4B</th>
          <th class="head-color">4X</th>
        </tr>
        <tr>
          <th class="head-color">양성결절</th>
          <th class="head-color">양성결절</th>
          <th class="head-color">경계선 결절</th>
          <th class="head-color">폐암의심</th>
          <th colspan="2" class="head-color">폐암 매우 의심</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="divide in subDivideList">
          <td>{{divide}}</td>
          <td>{{ getTable1(divide).count.total }}</td>
          <td>{{ getTable1(divide).count.n }}</td>
          <td>{{ getTable1(divide).count.y }}</td>
          <td>{{ getTable1(divide).y.y2 }}</td>
          <td>{{ getTable1(divide).y.y2b }}</td>
          <td>{{ getTable1(divide).y.y3 }}</td>
          <td>{{ getTable1(divide).y.y4a }}</td>
          <td>{{ getTable1(divide).y.y4b }}</td>
          <td>{{ getTable1(divide).y.y4x }}</td>
        </tr>
        <tr>
          <th>계</th>
          <th>{{ table1.sum.count.total }}</th>
          <th>{{ table1.sum.count.n }}</th>
          <th>{{ table1.sum.count.y }}</th>
          <th>{{ table1.sum.y.y2 }}</th>
          <th>{{ table1.sum.y.y2b }}</th>
          <th>{{ table1.sum.y.y3 }}</th>
          <th>{{ table1.sum.y.y4a }}</th>
          <th>{{ table1.sum.y.y4b }}</th>
          <th>{{ table1.sum.y.y4x }}</th>
        </tr>
        </tbody>
      </table>
    </fragment>

    <!-- 2차검진 결과 -->
    <fragment>
      <vs-row class="mt-8 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 정밀검진 결과(4A, 4B)</h5>
        </vs-col>
      </vs-row>
      <table v-if="table2"
             class="w-full text-center"
             cellspacing="0">
        <colgroup>
          <col width="200"/>
          <col width="233"/>
          <col width="233"/>
          <col width="233"/>
          <col width="233"/>
          <col width="233"/>
          <col width="233"/>
        </colgroup>
        <thead>
        <tr>
          <th rowspan="2">구분</th>
          <th colspan="3">1차검진 결과</th>
          <th colspan="3" class="head-color">정밀검진 결과</th>
        </tr>
        <tr>
          <th>폐암의심</th>
          <th>폐암매우의심</th>
          <th>계</th>
          <th class="head-color">폐암판정</th>
          <th class="head-color">폐암아님</th>
          <th class="head-color">계</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="divide in subDivideList">
          <td>{{divide}}</td>
          <td>{{ getTable2(divide).first.suspected }}</td>
          <td>{{ getTable2(divide).first.highly_suspected }}</td>
          <td>{{ getTable2(divide).first.total }}</td>
          <td>{{ getTable2(divide).precise.detected }}</td>
          <td>{{ getTable2(divide).precise.not_detected }}</td>
          <td>{{ getTable2(divide).precise.total }}</td>
        </tr>
        <tr>
          <th>계</th>
          <th>{{ table2.sum.first.suspected }}</th>
          <th>{{ table2.sum.first.highly_suspected }}</th>
          <th>{{ table2.sum.first.total }}</th>
          <th>{{ table2.sum.precise.detected }}</th>
          <th>{{ table2.sum.precise.not_detected }}</th>
          <th>{{ table2.sum.precise.total }}</th>
        </tr>
        </tbody>
      </table>
    </fragment>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import HttpRequest from '@/util/HttpRequest'
import XLSX from "xlsx";

export default {
  components: {
    SearchNavYearMonth,
    SearchNav,
  },
  props: {
  },
  data() {
    return {
      yearMonth: {year: new Date().getFullYear(), month: ''},
      table1: null,
      table2: null,
      subDivideList: [
        "영양교사",
        "영양사",
        "조리사",
        "조리실무사"
      ],
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {

  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      //
      const option = {
        params: {
          projectId: this.projectId,
          targetYear: this.yearMonth.year,
          targetMonth: this.yearMonth.month,
        },
      };

      if (!this.yearMonth.year) {
        delete option.params.targetYear
      }
      if (!this.yearMonth.month) {
        delete option.params.targetMonth
      }

      HttpRequest.get('/api/v1/summary/post/502_503', option)
      .then((response) => {
        const data = response
        this.table1 = data['502']
        this.table2 = data['503']
      })
      .catch((err) => {

      });
    },

    getTable1 (divide) {
      const data = this.table1[divide]
      if (data) {
        return this.table1[divide]
      }

      return {
        count: {
          total: 0,
          n: 0,
          y: 0,
        },
        y: {
          y2: 0,
          y2b: 0,
          y3: 0,
          y4a: 0,
          y4b: 0,
          y4x: 0,
        }
      }
    },
    getTable2 (divide) {
      const data = this.table2[divide]
      if (data) {
        return this.table2[divide]
      }

      return {
        first: {
          suspected: 0,
          highly_suspected: 0,
          total: 0,
        },
        precise: {
          detected: 0,
          not_detected: 0,
          total: 0,
        }
      }
    },

    onClickDownload () {
      this.excelDownFunc();
    },

    excelDownFunc () {
      const tableData = [
        ["1차검진 결과", "", "", "", "", "", "", "", "", ""],
        ["구분", "수검자 수", "검진 결과 인원", "", "이상소견", "", "", "", "", ""],
        ["", "", "이상소견 없음", "이상소견 있음", "2", "2b", "3", "4A", "4B", "4X"],
        ["", "", "", "", "양성결절", "양성결절", "경계선 결절", "폐암의심", "폐암 매우 의심", ""],
        // 나머지 데이터 배열
      ];

      for (const divide of this.subDivideList) {
        tableData.push([
          divide,
          this.getTable1(divide).count.total,
          this.getTable1(divide).count.n,
          this.getTable1(divide).count.y,
          this.getTable1(divide).y.y2,
          this.getTable1(divide).y.y2b,
          this.getTable1(divide).y.y3,
          this.getTable1(divide).y.y4a,
          this.getTable1(divide).y.y4b,
          this.getTable1(divide).y.y4x,
        ])
      }
      tableData.push([
        "계",
        this.table1.sum.count.total,
        this.table1.sum.count.n,
        this.table1.sum.count.y,
        this.table1.sum.y.y2,
        this.table1.sum.y.y2b,
        this.table1.sum.y.y3,
        this.table1.sum.y.y4a,
        this.table1.sum.y.y4b,
        this.table1.sum.y.y4x,
      ])
      tableData.push(["", "", "", "", "", "", "", "", "", ""])
      tableData.push(["정밀검진 결과(4A, 4B)", "", "", "", "", "", "", "", "", ""])
      tableData.push(["구분", "1차검진 결과", "", "", "정밀검진 결과", "", ""]);
      tableData.push(["", "폐암의심", "폐암 매우 의심", "계", "폐암의심", "폐암 매우 의심", "계"]);

      for (const divide of this.subDivideList) {
        tableData.push([
          divide,
          this.getTable2(divide).first.suspected,
          this.getTable2(divide).first.highly_suspected,
          this.getTable2(divide).first.total,
          this.getTable2(divide).precise.detected,
          this.getTable2(divide).precise.not_detected,
          this.getTable2(divide).precise.total,
        ])
      }
      tableData.push([
        "계",
        this.table2.sum.first.suspected,
        this.table2.sum.first.highly_suspected,
        this.table2.sum.first.total,
        this.table2.sum.precise.detected,
        this.table2.sum.precise.not_detected,
        this.table2.sum.precise.total,
      ])

      // 엑셀 워크북 생성
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(tableData);

      // 병합 정보 설정
      const t1 = 0
      const t2 = this.subDivideList.length + 6;
      ws["!merges"] = [
        // 1차검진 결과
        { s: { c: 0, r: t1 }, e: { c: 9, r: t1 } }, // 1차검진 결과
        { s: { c: 0, r: t1+1 }, e: { c: 0, r: t1+3 } }, // 구분
        { s: { c: 1, r: t1+1 }, e: { c: 1, r: t1+3 } }, // 수검자 수
        { s: { c: 2, r: t1+1 }, e: { c: 3, r: t1+1 } }, // 검진 결과 인원
        { s: { c: 4, r: t1+1 }, e: { c: 9, r: t1+1 } }, // 이상소견
        { s: { c: 2, r: t1+2 }, e: { c: 2, r: t1+3 } }, // 이상소견 없음
        { s: { c: 3, r: t1+2 }, e: { c: 3, r: t1+3 } }, // 이상소견 있음
        { s: { c: 8, r: t1+3 }, e: { c: 9, r: t1+3 } }, // 폐암 매우 의심

        // 2차검진 결과
        { s: { c: 0, r: t2 }, e: { c: 6, r: t2 } }, // 1차검진 결과
        { s: { c: 0, r: t2+1 }, e: { c: 0, r: t2+2} }, // 구분
        { s: { c: 1, r: t2+1 }, e: { c: 3, r: t2+1 } }, // 1차검진 결과
        { s: { c: 4, r: t2+1 }, e: { c: 6, r: t2+1 } }, // 정밀검진 결과
      ];

      // 워크북에 워크시트 추가
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // 엑셀 파일 다운로드
      XLSX.writeFile(wb, "폐암검진총괄(연도별).xlsx");
    },
  },
};
</script>

<style scoped lang="scss">

/* border */
table {
  border-left: 1px solid #cdcdcd;
  border-top: 1px solid #cdcdcd;
}
td,
th {
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
}


td,
th {
  font-size: 1rem;
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

th {
  background-color: #FAFAFA;
}
td {
  background-color: #ffffff;
}

.head-color {
  background-color: #F5F5FF;
}

</style>
